import { createPortal } from "react-dom";
import { AnimatePresence, motion } from "framer-motion";
import { Tag } from "components/DesignSystem/Tag/Tag";
import { FilingFlight, FLIGHT_DURATION_MS } from "v2/utils/useFilingFlights";

type FilingFlightLayerProps = {
  flight: FilingFlight | null;
};

const ADDED_LABEL = "Added";
const FLIGHT_EASE = [0.4, 0, 0.2, 1] as const;

const MS_IN_SECOND = 1000;

export const FilingFlightLayer = ({ flight }: FilingFlightLayerProps) => {
  if (!flight) return null;

  const { from, to } = flight;

  const targetX = to.left - from.left;
  const targetY = to.top - from.top;
  const targetWidth = to.width;

  return createPortal(
    <AnimatePresence>
      <motion.div
        key={flight.id}
        className="t-pointer-events-none t-fixed t-z-toast t-flex t-flex-col t-gap-1 t-rounded-xl t-border t-border-solid t-border-purple t-bg-surface-purple t-px-3 t-py-2.5 t-shadow-xl"
        style={{ left: from.left, top: from.top }}
        initial={{ x: 0, y: 0, width: from.width, opacity: 0.9 }}
        animate={{ x: targetX, y: targetY, width: targetWidth, opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{
          duration: FLIGHT_DURATION_MS / MS_IN_SECOND,
          ease: FLIGHT_EASE,
        }}
      >
        <span className="t-truncate t-text-subtext-sm t-text-text-60">
          {flight.title}
        </span>

        {flight.description && (
          <span className="t-truncate t-text-body-sm t-text-text-30">
            {flight.description}
          </span>
        )}

        <span className="t-flex">
          <Tag tagType="purple" rounded size="small">
            {ADDED_LABEL}
          </Tag>
        </span>
      </motion.div>
    </AnimatePresence>,
    document.body
  );
};
